export async function asyncForEach<T>(
  array: any[],
  callback: (item: T, index: number) => void
) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index)
  }
}
